import { render, staticRenderFns } from "./SkillConfirmations.vue?vue&type=template&id=655026c4&scoped=true"
import script from "./SkillConfirmations.vue?vue&type=script&lang=ts"
export * from "./SkillConfirmations.vue?vue&type=script&lang=ts"
import style0 from "./SkillConfirmations.vue?vue&type=style&index=0&id=655026c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655026c4",
  null
  
)

export default component.exports